import _axios from '../../apiClient'

export function saveCatalogo(payload) {
  return _axios.post(`/api/Catalogo/Save`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function getCatalogoByName(payload) {
  return _axios.get(`/api/Catalogo/find`,
    { params: {nombre: payload.nombre, idInstalacion:payload.idInstalacion, idCatalogo:payload.idCatalogo} },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}





export function getCatalogoImagen(payload) {
  
  
  return _axios.get(`/api/Catalogo/GetCatalogoImagen`,
    { params: {idCatalogo: payload.idCatalogo} },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getCatalogoCompleto(payload) {
  
  return _axios.get(`/api/Catalogo/GetCatalogoCompleto`,
  { params: payload },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getArticuloImagenes(payload) {

  return _axios.get(`/api/Articulo/GetArticuloImagenes`,
    { params: payload },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getPublicados() {
  return _axios.get(`/api/Catalogo/Publicados`,{
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    }).then(response => response.data).catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function savePublicarCatalogo(payload) {
  return _axios.post(`/api/Catalogo/Publicar`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function saveCambiarOrdenEntradaCatalogo(payload) {
  return _axios.post(`/api/Catalogo/CambiarCatalogoEntradaOrden`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function saveImagenCatalogo(payload) { 
  
  let newFile = payload.currentFile;
  let formData = new FormData();
  formData.append('file', newFile);

  return _axios.post(`/api/Catalogo/SaveImagen?idTemporal=${payload.idTemporal}&original=${payload.original}`,
  formData,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}
  
export function saveImagenCatalogoATemp(payload) {
  return _axios.post(`/api/Catalogo/MoverImagenATemporal`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function saveOcultarCatalogo(payload) {
  return _axios.post(`/api/Catalogo/Ocultar`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function saveTrasladarCatalogo(payload) {
  return _axios.post(`/api/Catalogo/Trasladar`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function saveBorrarCatalogo(payload) {
  return _axios.post(`/api/Catalogo/Borrar`,
  payload,
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}